export const ADD_TO_CART = "ADD_TO_CART";
export const IN_QTY = "IN_QTY";
export const DEC_QTY = "DEC_QTY";
export const REMOVE_QTY = "REMOVE_QTY";
export const CLEAR_QTY = "CLEAR_QTY";
